import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * FinancesCustomerView class extends JetView to create a financial customer view.
 */
export default class FinancesCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type to wide
            height: 600, // Set height of the view
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set inner layout type to wide
                    rows: [
                        {
                            view: 'tabbar', // Create a tabbar view
                            localId: 'tabbar', // Local ID for tabbar
                            height: 43, // Set height of the tabbar
                            options: [
                                // Define tab options
                                {
                                    id: 'customers.financial.informationFinancial', // ID for financial information tab
                                    value: _('Financiero'), // Localized value for the tab
                                },
                                {
                                    id: 'customers.financial.bankAccounts', // ID for bank accounts tab
                                    value: 'Cuentas Bancarias', // Value for the tab
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tabbar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
